import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_browser-request')({
  component: Outlet,
  staticData: { requiresAuth: true },
  beforeLoad: async ({ context, location }) => {
    await context.auth.requireAuth(location);
  },
});
